import Timeline from '@mui/icons-material/Timeline';

const LineIcon = (): JSX.Element => <Timeline fontSize="inherit" />;

export default LineIcon;
